module.exports = __webpack_public_path__ + "static/media/6_Focus_of_attention.46c39dd4.svg";